import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';
import {InputAdornment} from '@material-ui/core';
import {ReactComponent as SuccessTick} from "../../../assets/tick_icon_green.svg";

import IconAlert from '../icons/legacy/alert';
import TextField from './common/text-field';

const StyledIconAlert = styled(IconAlert)`
    padding-right: 12px;
`;
const StyledSuccessTick = styled(SuccessTick)`
    transform: translateY(0px);
`
const FormTextField = React.forwardRef((
    {
        className,
        label,
        helperText,
        value,
        placeHolder,
        onChange,
        onBlur,
        errorMessage,
        maxLength,
        minLength,
        inputMode,
        isSuccess,
        ...rest
    },
    ref
) => (
    <TextField
        {...rest}
        ref={ref}
        className={classnames('FormTextField', className, isSuccess?' validCode ':'')}
        error={!!errorMessage}
        label={label}
        variant="filled"
        placeholder={placeHolder}
        helperText={errorMessage || helperText}
        InputProps={{
            endAdornment: (!!errorMessage
                && (
                    <InputAdornment position="end">
                        <StyledIconAlert color="error" size={26} />
                    </InputAdornment>
                )||(isSuccess&&<StyledSuccessTick/>)),
        }}
        inputProps={{ // eslint-disable-line react/jsx-no-duplicate-props
            maxLength,
            minLength,
            inputMode
        }}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
    />
));

FormTextField.propTypes = {
    className: propTypes.string,
    label: propTypes.string,
    helperText: propTypes.string,
    value: propTypes.string,
    onChange: propTypes.func,
    onBlur: propTypes.func,
    errorMessage: propTypes.string,
    maxLength: propTypes.number,
};

FormTextField.displayName = 'FormTextField';

export default FormTextField;
